import React, {useState} from 'react';
import { CdsFormModal } from 'clayco-component-library';
import ManagementModalForm from './management-modal-form';
import Spinner from '../shared/spinner';
import * as yup from "yup";
import ApiProvider from "../../../apiProvider";
import Utility from "../shared/utility";
import { useMsal } from "@azure/msal-react";

const ManagementModal = ({
    show,
    onCloseModal,
    managementData,
    setManagementData,
    isEditMode = false,
}) => {
    const [loading, setLoading] = useState(false);
    const { instance, accounts } = useMsal();
    const [disableSubmitButton, setDisableSubmitButton] = useState(false);
    const [editableUsers, setEditableUsers] = useState([]);
    const apiProvider = new ApiProvider(instance, accounts[0]);


    const ManagementSchema = () => yup.object().shape({
            author: yup.array().of(yup.object({
                employeeNumber: yup.string().required("Author is required"),
                employeeName: yup.string().required("Author is required"),
                employeeIdentifier: yup.string().required("Author is required"),
            }).required("Author is required"))
            ,
      
            canEdit: yup.array()
                .of(
                yup.object({
                    employee: yup.object().required("At least one employee is required")
                })
                ).min(1, "At least one employee is required"),
    });

    const schema = () => yup.object().optional();

    function handleError(data) {
        console.log(data);
    }

    const saveManagement = async (formData, e) => {
        setDisableSubmitButton(true);
        setLoading(true);
      
        console.log("managementData", formData);
        const form = formData;
      
        const author = Array.isArray(form.author) ? form.author[0] : form.author;
      
        const oboUserModel = {
          AuthorizedUser: {
            Id: form.id || null,
            EmployeeNumber: author?.employeeNumber || null,
            EmployeeName: author?.employeeName || null,
            EmployeeIdentifier: author?.employeeIdentifier || null,
            Users: {}
          }
        };
      
        console.log("editableUsers", editableUsers);
        editableUsers.forEach((user) => {
            if (user?.employeeName && user?.employeeEmail) {
                oboUserModel.AuthorizedUser.Users[user.employeeNumber] = {
                    EmployeeName: user.employeeName,
                    EmployeeEmail: user.employeeEmail,
                };
            }
        });
      
        if (Array.isArray(form.canEdit)) {
          form.canEdit.forEach((item) => {
            const employee = item?.employee;
            if (
              employee?.employeeNumber &&
              employee?.displayName &&
              employee?.email
            ) {
              oboUserModel.AuthorizedUser.Users[employee.employeeNumber] = {
                EmployeeName: employee.displayName,
                EmployeeEmail: employee.email,
              };
            }
          });
        }
      
        console.log("oboUserModel", oboUserModel);
      
      const response = await apiProvider.Post("OnBehalfOf", oboUserModel);
      
        if (!response.error) {
          onCloseModal(true);
        } else {
          Utility.ShowMessageDlg();
          setDisableSubmitButton(false);
        }
      };

  return (
    <>
    <CdsFormModal
        title={"On-Behalf-Of Permissions"}
        schema={isEditMode ? schema: ManagementSchema}
        onError={handleError}
        onSubmit={saveManagement}
        show={show}
        handleCloseClick={onCloseModal}
        disablePrimaryButton={disableSubmitButton}
    >
        {loading ? 
            <Spinner show={loading}  />
        :
        <ManagementModalForm
            data={managementData}
            setData={setManagementData}
            classSchema={ManagementSchema}
            editableUsers={editableUsers}
            setEditableUsers={setEditableUsers}
        />
        }
    </CdsFormModal>
    </>
  );
}

export default ManagementModal;
